RivalIQ.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.SocialHandles = Backbone.Collection.extend({
        model: App.models.SocialHandle,

        initialize: function () {
            const me = this;

            me.listenTo(me, 'change:is_primary', me.setPrimary);
            me.listenTo(me, 'destroy', me.onDestroy);
            me.listenTo(me, 'add', me.onAdd);
        },

        getPrimary: function () {
            const me = this;
            return me.findWhere({
                is_primary: true
            });
        },

        setPrimary: function (model) {
            const me = this;
            if (model.get('is_primary')) {
                me.each(function (handle) {
                    if (handle.get('native_id') !== model.get('native_id')) {
                        handle.set({
                            is_primary: false
                        });
                    }
                });
            }
        },

        onAdd: function (model) {
            const me = this;

            // Cant use idAttribute because we want api requests to use the rival
            // id not the native id + we want to trigger an event on duplicate
            // add
            if (me.where({
                native_id: model.get('native_id')
            }).length > 1) {
                me.trigger('duplicate', model);
                me.remove(model);
            }

            if (me.length === 1) {
                return model.set({
                    is_primary: true
                });
            } else if (model.get('is_primary')) {
                me.setPrimary(model);
            }
        },

        onDestroy: function (model) {
            const me = this;

            if (model.get('is_primary')) {
                const first = me.at(0);
                if (first) {
                    first.set({
                        is_primary: true
                    });
                }
            }
        }
    });
});
